import styled from 'styled-components';
import { palette, Button } from '@m12s/component-library';
import { Container as WaitingContainer } from 'pages/Machine/MachineMainWrapper/styled';

const FullViewportOverlay = styled.div`
  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fafbfc;
  overflow: hidden;
`;

const FaiMainContainer = styled(WaitingContainer)`
  flex: 1;
  min-height: 0;
  width: 100%;
  padding-top: 1.5rem;
`;

const FaiBannerBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: fit-content;
  padding-top: 2rem;
`;

const DetailsBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  margin-bottom: 0.5rem;
`;

const MetaLine = styled.span`
  color: ${palette.Grey600};
  text-align: center;
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 2rem;
`;

const SetupElapsedMetaRow = styled(MetaLine)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  width: 100%;
`;

const EvaluationNote = styled.div`
  color: ${palette.Grey600};
  text-align: center;
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 2rem;
  max-width: 48rem;
  padding: 0 1.5rem;
`;

const FooterBar = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 1rem;
  width: 100%;
  box-sizing: border-box;
`;

const FooterButtonPrimary = styled(Button)`
  font-size: 1rem;
  background-color: ${palette.Indigo600};
  color: ${palette.White};
  &:hover {
    background-color: ${palette.Indigo700};
  }
`;

export {
  FullViewportOverlay,
  FaiMainContainer,
  FaiBannerBody,
  DetailsBlock,
  MetaLine,
  SetupElapsedMetaRow,
  EvaluationNote,
  FooterBar,
  FooterButtonPrimary,
};
